import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "flush", "singleBreadcrumbIsBackLink", "truncateToLevels", "wrapLevels", "role"];
import { LeftIcon, RightIcon } from 'foundations-assets';
import { Children, cloneElement, isValidElement } from 'react';
import styled from 'foundations-theming/utils';
import { useHeaderContext } from '../Header/Header';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { useToolBarContext } from '../ToolBar/ToolBar';
import { useBackButtonContext } from '../BackButton/BackButton';
import { MERCURY_LAYER } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledBreadcrumbInnerWrapper = styled.span.withConfig({
  displayName: "Breadcrumbs__StyledBreadcrumbInnerWrapper",
  componentId: "sc-1q8qrcf-0"
})(["display:inline-flex;height:100%;"]);
export const StyledIconWrapper = styled.div.withConfig({
  displayName: "Breadcrumbs__StyledIconWrapper",
  componentId: "sc-1q8qrcf-1"
})(({
  theme,
  $isBackLink
}) => {
  const isWithinToolBar = useToolBarContext().toolBar;
  return {
    display: 'flex',
    alignItems: 'center',
    marginInlineEnd: !isWithinToolBar ? '0.5em' : theme.space['100'],
    marginInlineStart: $isBackLink ? theme.space['0'] : '0.5em',
    fontSize: isWithinToolBar ? '20px' : '8px',
    inlineSize: isWithinToolBar ? '20px' : '8px',
    verticalAlign: isWithinToolBar ? 'middle' : undefined
  };
});
const renderBreadcrumb = (children, hasArrow, isBackLink) => {
  const ArrowIcon = isBackLink ? LeftIcon : RightIcon;
  return /*#__PURE__*/_jsxs(StyledBreadcrumbInnerWrapper, {
    children: [hasArrow && /*#__PURE__*/_jsx(StyledIconWrapper, {
      $isBackLink: isBackLink,
      children: /*#__PURE__*/_jsx(ArrowIcon, {
        color: "icon-core-subtle"
      })
    }), children]
  });
};
const StyledBreadcrumbItem = styled.span.withConfig({
  displayName: "Breadcrumbs__StyledBreadcrumbItem",
  componentId: "sc-1q8qrcf-2"
})(() => {
  return {
    position: 'relative',
    verticalAlign: 'middle',
    display: 'inline-block'
  };
});
const renderChild = (child, index, totalCrumbs, isOnlyChild = false, singleBreadcrumbIsBackLink = false
// isSROnly = false
) => {
  const ariaCurrent = !isOnlyChild && index === totalCrumbs - 1 ? 'location' : undefined;
  const isBackLink = isOnlyChild && singleBreadcrumbIsBackLink;
  const hasArrow = isBackLink || index !== 0;
  if ( /*#__PURE__*/isValidElement(child)) {
    return /*#__PURE__*/cloneElement(child, {
      //@ts-expect-error - TS doesn't like aria-current on non-HTML elements
      'aria-current': ariaCurrent,
      children: renderBreadcrumb(child.props.children, hasArrow, isBackLink),
      key: index
    });
  }
  return /*#__PURE__*/_jsx(StyledBreadcrumbItem, {
    children: renderBreadcrumb(child, hasArrow, isBackLink)
  });
};

// const renderTruncateDropdown = (children, defaultOpen) => {
//   return (
//     <Fragment>
//       <UIIcon className="private-breadcrumbs__arrow" name="right" />
//       {/* <UIDropdown
//         autoPlacement="vert"
//         tabIndex={-1}
//         buttonUse="transparent"
//         buttonText={ */}
//       <span className="align-center">
//         <UIIcon
//           name="ellipses"
//           className="m-right-0 m-left-1 m-top-1"
//           size={22}
//         />
//       </span>
//       {/* }
//         buttonClassName="p-x-0"
//         caretRenderer={() => null}
//         defaultOpen={defaultOpen}
//         menuWidth="auto"
//         placement="bottom right"
//       > */}
//       <UIList>{children}</UIList>
//       {/* </UIDropdown> */}
//     </Fragment>
//   );
// };

// const renderTruncatedBreadcrumbs = (
//   validChildren,
//   isOnlyChild,
//   singleBreadcrumbIsBackLink,
//   levelsToShow,
//   defaultOpen
// ) => {
//   const totalCrumbs = validChildren.length;
//   const innerCrumbs = validChildren.slice(1, -levelsToShow);
//   const innerCrumbLength = innerCrumbs.length;
//   const updatedLevelsToShow = innerCrumbLength ? levelsToShow : totalCrumbs - 1;

//   return (
//     <Fragment>
//       {renderChild(
//         validChildren[0],
//         0,
//         totalCrumbs,
//         isOnlyChild,
//         singleBreadcrumbIsBackLink
//       )}
//       {innerCrumbs.map((child, index) => {
//         return renderChild(
//           child,
//           index + 1,
//           totalCrumbs,
//           isOnlyChild,
//           singleBreadcrumbIsBackLink,
//           true
//         );
//       })}
//       {innerCrumbLength
//         ? renderTruncateDropdown(innerCrumbs, defaultOpen)
//         : null}
//       {validChildren.map((child, index) => {
//         if (index > totalCrumbs - updatedLevelsToShow - 1) {
//           return renderChild(
//             child,
//             index,
//             totalCrumbs,
//             isOnlyChild,
//             singleBreadcrumbIsBackLink
//           );
//         }
//         return null;
//       })}
//     </Fragment>
//   );
// };

const renderChildren = (children, singleBreadcrumbIsBackLink) => {
  const isValidChild = child => {
    if (typeof child === 'string') {
      return child.trim().length > 0;
    }
    return child;
  };
  const childrenArray = Children.toArray(children);
  const validChildren = childrenArray.filter(isValidChild);
  const totalCrumbs = validChildren.length;
  const isOnlyChild = totalCrumbs === 1;
  // let breadcrumbs;

  // if (truncateToLevels !== null && !isOnlyChild) {
  //   breadcrumbs = renderTruncatedBreadcrumbs(
  //     validChildren,
  //     isOnlyChild,
  //     singleBreadcrumbIsBackLink,
  //     truncateToLevels,
  //     defaultOpen
  //   );
  // } else {
  const breadcrumbs = Children.map(validChildren, (child, index) => {
    return renderChild(child, index, totalCrumbs, isOnlyChild, singleBreadcrumbIsBackLink);
  });
  // }

  if (isOnlyChild && !singleBreadcrumbIsBackLink) {
    breadcrumbs.push( /*#__PURE__*/_jsx("span", {
      children: renderBreadcrumb(null, true, false)
    }, "x"));
  }
  return breadcrumbs;
};
export const StyledNav = styled.nav.withConfig({
  displayName: "Breadcrumbs__StyledNav",
  componentId: "sc-1q8qrcf-3"
})(({
  $cssStyles,
  $flush,
  $noWrap,
  theme
}) => {
  const isInHeader = useHeaderContext().header;
  const isInToolBar = useToolBarContext().toolBar;
  const isInBackButton = useBackButtonContext().backButton;
  return Object.assign({
    fontSize: !isInBackButton ? theme.typography['detail-100'].fontSize : 'inherit',
    color: theme.color['text-core-subtle'],
    marginTop: isInHeader || isInToolBar || isInBackButton ? theme.space['0'] : theme.space['400'],
    overflow: 'hidden',
    padding: `0 ${$flush ? theme.space['0'] : theme.space['1100']}`,
    position: 'relative',
    textOverflow: 'ellipsis',
    display: isInBackButton ? 'inline-block' : 'block',
    zIndex: MERCURY_LAYER,
    whiteSpace: $noWrap ? 'nowrap' : undefined
  }, $cssStyles);
});
export const Breadcrumbs = _ref => {
  let {
      children,
      flush = false,
      singleBreadcrumbIsBackLink = true,
      truncateToLevels,
      wrapLevels = false,
      role = 'navigation'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    header
  } = useHeaderContext();
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const isWithinToolBar = useToolBarContext().toolBar;
  if (header || isWithinToolBar) {
    flush = true;
  }
  return /*#__PURE__*/_jsx(StyledNav, Object.assign({
    role: role,
    $flush: flush,
    $noWrap: !wrapLevels && truncateToLevels === null,
    $cssStyles: cssStyles
  }, domProps, {
    children: renderChildren(children, singleBreadcrumbIsBackLink
    // truncateToLevels,
    )
  }));
};